/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCodingBootcampTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCodingBootcamp,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Code Together!",
    "Coding Bootcamp Awaits!",
    "Unleash Your Inner Developer!",
  ],
  title: "Coding Bootcamp",
  description: "Organize an engaging coding bootcamp.",
  longDescription:
    "Gather your friends for a coding bootcamp! Choose a date, decide on programming languages to learn, and plan activities for the workshop!",
  emoji: "💻",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Coding Bootcamp",
          emoji: "💻",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the coding bootcamp?",
          emoji: "📅",
          completeAction: {
            question: "Decide on programming languages to learn?",
            description:
              "What programming languages should we explore during the bootcamp?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What languages should we consider?",
                emoji: "🔧",
                completeAction: {
                  question: "Decide on tools needed?",
                  description: "What tools should we gather for coding?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🛠",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Code Away!",
    outroDescription: "Your coding bootcamp plans are set! Enjoy the learning!",
  },
};
